(function () {
  function init(bar) {
    if (!bar || bar.avahelSatcReady) return;
    bar.avahelSatcReady = true;

    var offset = parseInt(bar.getAttribute('data-satc-offset'), 10) || 500;
    var visible = false;

    function setVisible(next) {
      if (next === visible) return;
      visible = next;

      if (next) {
        bar.hidden = false;
        window.requestAnimationFrame(function () {
          bar.classList.add('is-visible');
        });
      } else {
        bar.classList.remove('is-visible');
        window.setTimeout(function () {
          if (!visible) bar.hidden = true;
        }, 300);
      }

      /* Lets the floating WhatsApp button lift out of the way */
      document.body.classList.toggle('avahel-satc-visible', next);
    }

    /* Prefer watching the real add to cart button so the bar appears
       exactly when the customer loses sight of it. */
    var mainButton =
      document.querySelector('product-form .product-form__submit') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('form[action*="/cart/add"] [name="add"]');

    if (mainButton && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          // Show only once the button has scrolled ABOVE the viewport
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        },
        { threshold: 0, rootMargin: '0px' }
      );
      observer.observe(mainButton);
    } else {
      var onScroll = function () {
        setVisible(window.pageYOffset > offset);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Variant select keeps price, image and button in sync */
    var select = bar.querySelector('[data-satc-select]');
    var priceEl = bar.querySelector('[data-satc-price]');
    var imageEl = bar.querySelector('[data-satc-image]');
    var submit = bar.querySelector('[data-satc-submit]');
    var submitText = bar.querySelector('[data-satc-button-text]');

    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;

        if (priceEl) {
          var now = opt.getAttribute('data-price') || '';
          var was = opt.getAttribute('data-compare') || '';
          priceEl.innerHTML = was
            ? '<span class="satc__price-now">' + now + '</span><s class="satc__price-was">' + was + '</s>'
            : '<span class="satc__price-now">' + now + '</span>';
        }

        var img = opt.getAttribute('data-image');
        if (imageEl && img) imageEl.src = img;

        if (submit) {
          submit.disabled = opt.disabled;
          if (submitText && opt.disabled) submitText.textContent = 'Sold out';
        }
      });
    }

    /* Quantity stepper */
    var qtyInput = bar.querySelector('[data-satc-qty-input]');
    bar.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-satc-qty]');
      if (!btn || !qtyInput) return;

      var current = parseInt(qtyInput.value, 10) || 1;
      var next = btn.getAttribute('data-satc-qty') === 'up' ? current + 1 : current - 1;
      qtyInput.value = next < 1 ? 1 : next;
    });

    /* Add to cart without leaving the page, matching the theme's cart style.
       Falls back to a normal form post if anything is unavailable. */
    var form = bar.querySelector('form[action*="/cart/add"]');

    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var target =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (!target || typeof target.renderContents !== 'function') {
          form.submit();
          return;
        }

        if (submit) submit.setAttribute('aria-busy', 'true');
        if (submitText) submitText.textContent = 'Adding...';

        var data = new FormData(form);
        data.append('sections', 'cart-notification-product,cart-notification-button,cart-icon-bubble');
        data.append('sections_url', window.location.pathname);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: data
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (state) {
            if (state.status) throw new Error(state.description || 'Add to cart failed');
            target.renderContents(state);
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (submit) submit.removeAttribute('aria-busy');
            if (submitText) {
              submitText.textContent = bar.getAttribute('data-satc-label') || 'Add to cart';
            }
          });
      });
    }
  }

  function boot() {
    var bars = document.querySelectorAll('[data-satc]');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
